import { render, staticRenderFns } from "./ChatMoment.vue?vue&type=template&id=227c8054&"
import script from "./ChatMoment.vue?vue&type=script&lang=js&"
export * from "./ChatMoment.vue?vue&type=script&lang=js&"
import style0 from "./ChatMoment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports